import axios from "axios";

export const getLatestNews = async () => {
  const res = await axios.get("https://alnabaatech.com.ly/api/news/latest");
  return res.data;
};